import React from "react";
import "./../stylesheets/cardBox.css";
import CardBox from "./../componentsEnhanced/CardBox";
import { Link } from "react-router-dom";
import Breadcrumb from "react-bootstrap/Breadcrumb";

const LandingKpiDashboard = () => (
  <div>
    <Breadcrumb>
      <Breadcrumb.Item href="">
        <Link to="/navigate_new">Home</Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item href="">
        <Link to="/welcomeautomatekpi">Automate KPI</Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item href="/welcomeautomatekpi/landingkpidashboard" active>
        {" "}
        KPI Dashboard
      </Breadcrumb.Item>
    </Breadcrumb>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        flexDirection: "column",
        height: "100%",
        gap: "80px",
      }}
    >
      <div style={{ paddingTop: "5%" }}>
        <div style={{ margin: "auto" }}>
          <h1 style={{ color: "#464646" }}>KPI Dashboard</h1>
        </div>
      </div>

      <div
        className=""
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "row",
          width: "100%",
          height: "100%",
          gap: "100px",
        }}
      >
        <CardBox
          path={"/kpidashboardopenloop"}
          title={"Open Loop"}
          info={"Dashboard to view Camera, Radar, Lidar artifacts."}
        />
        <CardBox
          path={"/kpidashboardcloseloop"}
          title={"Close Loop"}
          info={"Dashboard to view KPI Detailed Dashboad and KPI Summary Dashboard artifacts."}
        />
      </div>
    </div>
  </div>
);

export default LandingKpiDashboard;
